// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content___YGR1","sendOtp":"AuthorizeToLogin_sendOtp__4dovG"};